"use client";

import { BigAudioPlayer } from "@/components/audioPlayers/BigAudioPlayer";
import { BlogHeading3 } from "@/components/content/blog/BlogHeading3";
import { BlogHeading4 } from "@/components/content/blog/BlogHeading4";
import { NormalText } from "@/components/text/NormalText";

export function BlogAudioExample({
  heading,
  leftAudioSource,
  rightAudioSource,
  isHeading3,
  className,
}: {
  heading: string;
  leftAudioSource: string;
  rightAudioSource: string;
  isHeading3: boolean;
  className?: string;
}) {
  return (
    <div className={className}>
      {isHeading3 ?
        <BlogHeading3>{heading}</BlogHeading3>
      : <BlogHeading4>{heading}</BlogHeading4>}

      <div className="sm: mt-2 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
        <div>
          <NormalText elementType="p">Before</NormalText>
          <BigAudioPlayer
            source={leftAudioSource}
            includePreviewText={false}
            bigWaves={false}
            filename={null}
            className="mt-2 rounded-3xl bg-gray-900/5 p-4"
          />
        </div>
        <div className="w-full">
          <NormalText elementType="p">After</NormalText>
          <BigAudioPlayer
            source={rightAudioSource}
            includePreviewText={false}
            bigWaves={false}
            filename={null}
            className="mt-2 rounded-3xl bg-gray-900/5 p-4"
          />
        </div>
      </div>
    </div>
  );
}
